export default "__VITE_ASSET__ZX4PtuFv__"